import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJobByCategoriesCount } from "../../slice/workerJobSlice";
import { useNavigate } from "react-router-dom";

const WorkerJobByCategoriesCount = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const { jobCategoriesCount, loading, error } = useSelector(
        (state) => state.workerJob
    );

    useEffect(() => {
        if (!token) return;
        dispatch(getJobByCategoriesCount(token));
    }, [token, dispatch]);

    const handleClick = (category) => {
        console.log("category", category);
        navigate("/worker-jobs", {
            state: { 
                fromExternal: true,
                selectedCategory: category.id,
            },
        });
    };

    // console.log("jobCategoriesCount", jobCategoriesCount);


    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="fw-bold text-primary mb-4 border-bottom pb-3">
                    Job By Categories
                </h4>

                {/* 🔄 Loading */}
                {loading && (
                    <div className="d-flex justify-content-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                {/* ❌ Error */}
                {!loading && error && (
                    <div className="alert alert-danger text-center">
                        {error}
                    </div>
                )}

                {!loading && !error && (
                    <div className="row g-3">
                        {jobCategoriesCount.map((job, index) => (
                            <div key={index} className="col-md-4">
                                <div className="card shadow-sm"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleClick(job)}
                                >
                                    <div className="card-body d-flex justify-content-between align-items-center">
                                        <h6 className="mb-0 text-capitalize fw-semibold">{job.name}</h6>
                                        <span className="text-muted">{job.total}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WorkerJobByCategoriesCount;
